module.exports = function (Vue, config) {
  Vue.mixin({
    created: function () {
      this.$config = config
    }
  })
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-config/index.js
// module id = 255
// module chunks = 0